export const globals_actions = {
  async enableLoader() {
    this.loaderStatusState = true;
  },

  async disableLoader() {
    this.loaderStatusState = false;
  },

  setErrorMessage(message) {
    this.errorMessageState = message;
  },

  setInfoMessage(message) {
    this.infoMessageState = message;
  }
};

export const globals_getters = {
  loaderStatus(state) {
    return state.loaderStatusState;
  },
  errorMessage(state) {
    return state.errorMessageState;
  },
  infoMessage(state) {
    return state.infoMessageState;
  }
};

export const globals_state = {
  loaderStatusState: false,
  errorMessageState: null,
  infoMessageState: null
};
